import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, UserMeResponse } from '../lib/api';

interface AuthContextValue {
  user: UserMeResponse | null;
  token: string | null;
  loading: boolean;
  login(email:string, password:string): Promise<void>;
  register(data: {email:string; password:string; name:string; birthDate:string; phone?:string; cpf?:string}): Promise<void>;
  logout(): void;
  refresh(): Promise<void>;
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined);

const TOKEN_KEY = 'cg_token';

export function AuthProvider({children}:{children:React.ReactNode}) {
  const [user, setUser] = useState<UserMeResponse|null>(null);
  const [token, setToken] = useState<string|null>(() => localStorage.getItem(TOKEN_KEY));
  const [loading, setLoading] = useState<boolean>(!!token);

  const refresh = useCallback(async () => {
    if(!token){ setUser(null); return; }
    try { const me = await api.me(token); setUser(me); } catch(e){ console.warn('refresh /me falhou', e); }
  }, [token]);

  useEffect(() => { if(token) { refresh().finally(()=>setLoading(false)); } else { setLoading(false); } }, [token, refresh]);

  async function login(email:string, password:string){
    const { token: tk } = await api.login(email,password);
    localStorage.setItem(TOKEN_KEY, tk); setToken(tk);
    await refresh();
  }
  async function register(data: {email:string; password:string; name:string; birthDate:string; phone?:string; cpf?:string}){
    const { token: tk } = await api.register(data);
    localStorage.setItem(TOKEN_KEY, tk); setToken(tk);
    await refresh();
  }
  function logout(){ localStorage.removeItem(TOKEN_KEY); setToken(null); setUser(null); }

  const value: AuthContextValue = { user, token, loading, login, register, logout, refresh };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth(){
  const ctx = useContext(AuthContext);
  if(!ctx) throw new Error('useAuth deve ser usado dentro de AuthProvider');
  return ctx;
}
